<template>
  <div />
</template>

<script>

import BigNumber from "bignumber.js";
import { BeaconWallet } from "@taquito/beacon-wallet";

export default {
  name: 'WalletConnector',
  async mounted(){
    const wallet = new BeaconWallet({
      name: 'Kolibri Governance Portal',
      iconUrl: 'https://kolibri-data.s3.amazonaws.com/logo.png',
      appUrl: 'https://kolibri.finance',
    })

    this.$eventBus.$on('wallet-reconnect', async () => {
      this.$store.currentkDAOHoldings = null
      this.$store.wallet = null
      localStorage.removeItem(this.$store.nodeOverrideKey)
      await wallet.client.clearActiveAccount()
      this.$eventBus.$emit('wallet-connect')
    })

    this.$eventBus.$on('wallet-connect', async (activeAccount) => {
      try {
        if (activeAccount === undefined){
          await wallet.requestPermissions({
            network: {
              type: this.$store.network === 'sandboxnet' ? 'custom' : this.$store.network,
              rpcUrl: this.$store.nodeURL
            }
          })
        }

        this.$store.walletAddress = await wallet.getPKH()
        this.$store.wallet = wallet

        this.$store.tezosToolkit.setWalletProvider(wallet)

        await this.updateBalances()

        this.$eventBus.$emit('wallet-connect-success')
      } catch(e) {
        console.error(e)
      }
    })

    this.$eventBus.$on('update-balances', async () => {
      this.$store.currentkDAOHoldings = null
      await this.updateBalances()
    })

    // Go check for an active account, and if it exists just use that
    const activeAccount = await wallet.client.getActiveAccount()
    if (activeAccount !== undefined){
      this.$eventBus.$emit('wallet-connect', activeAccount)
    }
  },
  methods: {
    async updateBalances(){
      const lockupVaultAddress = this.$store.contracts.VOTING_VAULTS[this.$store.walletAddress]

      this.$store.kDAOToken = await this.$store.tezosToolkit.wallet.at(this.$store.contracts.DAO_TOKEN)

      this.$store.kDAOTokenContractStorage = await this.$store.kDAOToken.storage()

      let balance, checkpointCount
      if (lockupVaultAddress !== undefined){
        balance = await this.$store.kDAOTokenContractStorage.balances.get(lockupVaultAddress)
        checkpointCount = await this.$store.kDAOTokenContractStorage.numCheckpoints.get(lockupVaultAddress)
        this.$store.isVestingVault = true
      } else {
        balance = await this.$store.kDAOTokenContractStorage.balances.get(this.$store.walletAddress)
        checkpointCount = await this.$store.kDAOTokenContractStorage.numCheckpoints.get(this.$store.walletAddress)
      }

      if (balance === undefined){
        this.$store.currentkDAOHoldings = new BigNumber(0)
        this.$store.kDAOCheckpointCount = new BigNumber(0)
      } else {
        this.$store.currentkDAOHoldings = balance
        this.$store.kDAOCheckpointCount = checkpointCount
      }
    }
  },
}
</script>
